module.exports = __webpack_public_path__ + "static/media/offline.5f8ca876.svg";